import NewProfilesStatisticsReducer from './NewProfilesStatisticsReducer';

export default from './NewProfilesStatisticsContainer';
export const NewProfilesStatisticsReducers = {
  NewProfilesStatisticsReducer,
};
